import { Record } from 'immutable';

const PropertyRecord = Record({
  id: 0,
  chain: null,
  brand: null,
  pid: null,
  name: null,
  address1: null,
  address2: null,
  address3: null,
  city: null,
  stateProvinceCode: null,
  countryCode: null,
  postalCode: null,
  phoneNr: null,
  faxNr: null,
  email: null,
  contactFirstNm: null,
  contactLastNm: null,
  subscriber: null,
  manuallyAdded: null,
  payorType: null
});

export class Property extends PropertyRecord {
  id: number;
  chain: string;
  brand: string;
  pid: string;
  name: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  stateProvinceCode: string;
  countryCode: string;
  postalCode: string;
  phoneNr: string;
  faxNr: string;
  email: string;
  contactFirstNm: string;
  contactLastNm: string;
  subscriber: boolean;
  manuallyAdded: boolean;
  payorType: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/property.ts